// extracted by mini-css-extract-plugin
export default {"flexColumn":"styles_flexColumn__bsKEF","gridItem":"styles_gridItem__p873o","fullView":"styles_fullView__yE421","shimmer":"styles_shimmer__WWiYr"};